import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import CreateProcedureModal from './CreateProcedureModal';

const CreateProcedureModalBridge = react2angular(CreateProcedureModal, [
  'onClose'
]);

export default CreateProcedureModalBridge;
